import React, { useEffect } from 'react';
import {
    FaUsers,
    FaCopy,
    FaWallet,
    FaUserCheck,
    FaClock,
    FaCrown,
    FaShareAlt
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useTheme } from '../../context/ThemeContext';
import { useUser } from '../../context/UserContext';
import api from '../../api/Api';

const MyReferral = () => {
    const { isDarkMode } = useTheme();
    const [loading, setLoading] = React.useState(true);
    const G = '#d4af37';
    const G2 = '#f0c842';

    const bg = isDarkMode ? '#0b0b0b' : '#f5f1e8';
    const card = isDarkMode ? '#151515' : '#ffffff';
    const border = isDarkMode
        ? 'rgba(212,175,55,.12)'
        : 'rgba(212,175,55,.2)';

    const text = isDarkMode ? '#f5f5f5' : '#111';
    const muted = isDarkMode
        ? 'rgba(255,255,255,.55)'
        : '#7b6d58';

    const [referrals, setReferals] = React.useState([]);
    const { user } = useUser();
    const referralCode = user?.USER?.my_code || 'N/A';
    console.log("referrals", referrals)
    useEffect(() => {
        fetchReferrals();
    }, []);

    const fetchReferrals = async () => {

        try {

            setLoading(true);

            const { data } = await api.get('my-referral');

            if (data?.status) {

                setReferals(data?.data || []);
            }

        } catch (err) {

            console.log(err);

        } finally {

            setLoading(false);

        }
    };


    const copyCode = () => {
        navigator.clipboard.writeText(referralCode);
        toast.success('Referral code copied');
    };

    const stats = [
        {
            icon: <FaUsers />,
            label: 'Total Referrals',
            value: '124',
        },
        {
            icon: <FaUserCheck />,
            label: 'Active Users',
            value: '87',
        },
        {
            icon: <FaWallet />,
            label: 'Total Earnings',
            value: '₹52,450',
        },
        {
            icon: <FaClock />,
            label: 'Pending Rewards',
            value: '₹4,320',
        },
    ];

    return (
        <div
            style={{
                minHeight: '100vh',
                background: bg,
            }}
        >
            <div className="container">

                {/* HERO SECTION */}
                <div
                    style={{
                        background: card,
                        borderRadius: 24,
                        border: `1px solid ${border}`,
                        padding: '35px',
                        marginBottom: 25,
                        position: 'relative',
                        overflow: 'hidden',
                        boxShadow: isDarkMode
                            ? '0 10px 40px rgba(0,0,0,.5)'
                            : '0 10px 40px rgba(212,175,55,.08)',
                    }}
                >

                    {/* Glow */}
                    <div
                        style={{
                            position: 'absolute',
                            top: -100,
                            right: -100,
                            width: 250,
                            height: 250,
                            borderRadius: '50%',
                            background: 'rgba(212,175,55,.08)',
                            filter: 'blur(60px)',
                        }}
                    />

                    {/* top border */}
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: 3,
                            background: `linear-gradient(90deg, transparent, ${G}, ${G2}, transparent)`,
                        }}
                    />

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center', // Sab kuch vertically center rahega
                            justifyContent: 'space-between',
                            gap: '20px',
                            padding: '16px 20px',
                            borderRadius: '16px',
                            background: isDarkMode ? '#111' : '#fff',
                            border: `1px solid ${isDarkMode ? '#222' : '#eee'}`,
                            flexWrap: 'wrap',
                            boxShadow: isDarkMode ? 'none' : '0 4px 12px rgba(0,0,0,0.03)',
                        }}
                    >
                        {/* LEFT: Heading and Subtext */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                            <h4 style={{
                                margin: 0,
                                fontSize: '16px',
                                fontWeight: 800,
                                color: text,
                                letterSpacing: '-0.3px'
                            }}>
                                Refer & Earn
                            </h4>
                            <p style={{
                                margin: 0,
                                fontSize: '12px',
                                color: muted,
                                fontWeight: 500
                            }}>
                                Invite friends to get rewards
                            </p>
                        </div>

                        {/* RIGHT: Action Container */}
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                background: isDarkMode ? '#1a1a1a' : '#f8f8f8',
                                borderRadius: '12px',
                                border: `1px solid ${isDarkMode ? '#333' : '#e5e5e5'}`,
                                minWidth: 'fit-content',
                                padding: '8px 12px',
                            }}
                        >
                            {/* Referral Code Text */}
                            <span
                                style={{
                                    fontSize: '15px',
                                    fontWeight: 700,
                                    color: text,
                                    fontFamily: 'SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace',
                                    letterSpacing: '1px',
                                    marginRight: '8px'
                                }}
                            >
                                {referralCode}
                            </span>

                            {/* Vertical Line Separator */}
                            <div style={{ width: '1px', height: '24px', background: isDarkMode ? '#333' : '#ddd' }} />

                            {/* Action Buttons Group */}
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                }}
                            >
                                {/* Vertical Line */}
                                <div
                                    style={{
                                        width: "1px",
                                        height: "24px",
                                        background: isDarkMode ? "#333" : "#ddd",
                                        flexShrink: 0,
                                    }}
                                />

                                {/* Buttons */}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                    }}
                                >
                                    {/* Copy Button */}
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            copyCode();
                                        }}
                                        title="Copy"
                                        style={{
                                            width: "36px",
                                            height: "36px",
                                            borderRadius: "8px",
                                            border: "none",
                                            outline: "none",
                                            background: "transparent",
                                            color: G,
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            transition: "0.2s",
                                            flexShrink: 0,
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = `${G}15`;
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "transparent";
                                        }}
                                    >
                                        <FaCopy
                                            size={16}
                                            style={{
                                                pointerEvents: "none",
                                            }}
                                        />
                                    </button>

                                    {/* Share Button */}
                                    <button
                                        type="button"
                                        onClick={async (e) => {
                                            e.stopPropagation();

                                            try {
                                                if (navigator.share) {
                                                    const shareUrl = `${window.location.origin}/register/${referralCode}`;
                                                    await navigator.share({
                                                        title: "Join me!",
                                                        text: `Use my referral code: ${referralCode}`,
                                                        url: shareUrl
                                                    });
                                                } else {
                                                    await navigator.clipboard.writeText(window.location.href);
                                                    alert("Link copied!");
                                                }
                                            } catch (err) {
                                                console.log("Share cancelled", err);
                                            }
                                        }}
                                        style={{
                                            padding: "0 16px",
                                            height: "36px",
                                            borderRadius: "8px",
                                            border: "none",
                                            outline: "none",
                                            background: G,
                                            color: "#000",
                                            fontWeight: 700,
                                            fontSize: "13px",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "6px",
                                            boxShadow: `0 2px 8px ${G}40`,
                                            transition: "0.2s",
                                            flexShrink: 0,
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = "scale(1.03)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = "scale(1)";
                                        }}
                                    >
                                        <FaShareAlt
                                            size={12}
                                            style={{
                                                pointerEvents: "none",
                                            }}
                                        />
                                        <span style={{ pointerEvents: "none" }}>Share</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* STATS */}
                <div className="row g-3 mb-4">
                    {stats.map((item, i) => (
                        <div key={i} className="col-6 col-md-3">
                            <div
                                style={{
                                    background: card,
                                    borderRadius: 18,
                                    border: `1px solid ${border}`,
                                    padding: '22px 15px',
                                    textAlign: 'center',
                                    transition: '.3s',
                                }}
                            >
                                <div
                                    style={{
                                        width: 50,
                                        height: 50,
                                        borderRadius: '50%',
                                        background: 'rgba(212,175,55,.12)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0 auto 12px',
                                        color: G,
                                        fontSize: 18,
                                    }}
                                >
                                    {item.icon}
                                </div>

                                <div
                                    style={{
                                        fontSize: 24,
                                        fontWeight: 900,
                                        color: G,
                                    }}
                                >
                                    {item.value}
                                </div>

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: muted,
                                        marginTop: 6,
                                    }}
                                >
                                    {item.label}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* REFERRAL TABLE */}
                <div
                    style={{
                        background: card,
                        borderRadius: 24,
                        border: `1px solid ${border}`,
                        overflow: 'hidden',
                    }}
                >

                    {/* Header */}
                    <div
                        style={{
                            padding: '22px 25px',
                            borderBottom: `1px solid ${border}`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            gap: 10,
                        }}
                    >
                        <div>
                            <div
                                style={{
                                    fontSize: 20,
                                    fontWeight: 800,
                                    color: text,
                                }}
                            >
                                Referral History
                            </div>

                            <div
                                style={{
                                    fontSize: 12,
                                    color: muted,
                                    marginTop: 5,
                                }}
                            >
                                Your invited users and rewards
                            </div>
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                                color: G,
                                fontWeight: 700,
                                fontSize: 13,
                            }}
                        >
                            <FaCrown />
                            Premium Referral Program
                        </div>
                    </div>

                    {/* TABLE */}
                    <div style={{ overflowX: 'auto' }}>
                        <table
                            style={{
                                width: '100%',
                                minWidth: 700,
                                borderCollapse: 'collapse',
                            }}
                        >
                            <thead>
                                <tr
                                    style={{
                                        background: isDarkMode
                                            ? 'rgba(212,175,55,.03)'
                                            : 'rgba(212,175,55,.05)',
                                    }}
                                >
                                    {['User', 'Join Date', 'Status', 'Earnings'].map((h) => (
                                        <th
                                            key={h}
                                            style={{
                                                padding: '18px',
                                                textAlign: 'left',
                                                color: muted,
                                                fontSize: 11,
                                                letterSpacing: 2,
                                                textTransform: 'uppercase',
                                                fontWeight: 700,
                                            }}
                                        >
                                            {h}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {referrals.map((item) => (
                                    <tr
                                        key={item.id}
                                        style={{
                                            borderTop: `1px solid ${border}`,
                                        }}
                                    >
                                        <td style={{ padding: 18 }}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 12,
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: 45,
                                                        height: 45,
                                                        borderRadius: '50%',
                                                        background: `linear-gradient(135deg, ${G}, ${G2})`,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        color: '#000',
                                                        fontWeight: 900,
                                                    }}
                                                >
                                                    <div className="user-avatar">
                                                        {item.profile_image ? (
                                                            <img
                                                                src={item.profile_image}
                                                                alt={item.name}
                                                                style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                                                            />
                                                        ) : (
                                                            <div className="initial-avatar">
                                                                {item.name.charAt(0).toUpperCase()}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div>
                                                    <div
                                                        style={{
                                                            color: text,
                                                            fontWeight: 700,
                                                        }}
                                                    >
                                                        {item.name}
                                                    </div>


                                                </div>
                                            </div>
                                        </td>

                                        <td
                                            style={{
                                                padding: 18,
                                                color: muted,
                                                fontSize: 14,
                                            }}
                                        >
                                            {item?.created_at ? new Date(item.created_at).toLocaleDateString() : "N/A"}                                        </td>

                                        <td style={{ padding: 18 }}>
                                            <span
                                                style={{
                                                    padding: '6px 14px',
                                                    borderRadius: 30,
                                                    fontSize: 11,
                                                    fontWeight: 700,
                                                    background:
                                                        item.status === 'Active'
                                                            ? 'rgba(34,197,94,.12)'
                                                            : 'rgba(245,158,11,.12)',
                                                    color:
                                                        item.status === 'Active'
                                                            ? '#22c55e'
                                                            : '#f59e0b',
                                                }}
                                            >
                                                {item.stake_status}
                                            </span>
                                        </td>

                                        <td
                                            style={{
                                                padding: 18,
                                                color: G,
                                                fontWeight: 800,
                                                fontSize: 15,
                                            }}
                                        >
                                            {item.team_business}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyReferral;